import React from "react";
import Transferencia from "../../components/acesso-rapido/transferir/Transferir";

export default function () {
  return <Transferencia />;
}
